<template>
  <div class="bankmanage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="radiobut" v-if="permission.close_audit">
      <el-badge :value="examinelist" class="examine_length">
      <el-radio-group v-model="margintap">
        <el-radio-button label="0">项目收尾</el-radio-button>
       
          <el-radio-button label="1">审核列表</el-radio-button>
       
      </el-radio-group>
    </el-badge>
    </div>
    <!-- <div class="topcrud" v-if="!permission.close_audit">
      <div class="messagetitle"><span>项目收尾</span></div>
    </div> -->
    <Paymentmanage ref="paymentmanage" v-if="margintap == 0 " @rowdata="rowdata" :option='option' :files="files" :showHide='optionColumn'/>
  
    <Examinelist v-if="margintap == 1" @rowdata="rowdata" :files="files" />
  </div>
</template>

<script>
import * as api from "@/api/zd/projectconclusion";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Paymentmanage from "./components/projectconclusionmanageindex";
import Examinelist from "./components/examinelist";
import { mapGetters } from "vuex";

export default {
  name: "bankmanage",
  data() {
    return {
      margintap: 0,
      examinelist: 0,
      financial:false,
      form: [],
      files: [],
      authority: false,
      optionColumn: [],
      option: {
        menu:false,
        searchShow:false,
        menuType: "button",
        addBtn: false,
        menuWidth: 210,
        menuAlign: "center",
        card: true,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        refreshBtn:false,
        // menuWidth: 300,
        labelWidth: 100,
        selection: true,
        selectionWidth: 45,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "项目编号/项目名称/客户名称",
            placeholder: "项目编号/项目名称/客户名称",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow:true
           
          },
          {
            sortable: "custom",
            label: "项目编号",
            prop: "number",
            width: "120",
            fixed: true,
            display:false
          },
          {
            label: "项目名称",
            prop: "name",
            width: "250",
            slot:true,  
            display:false
          },
          {
            label: "收尾状态",
            prop: "closeState",
            type: "select",
            search: true,
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=close_state",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "number"
          },
          {
            label: "客户名称",
            prop: "custId",
            width: "180",
            type: "select",
            filterable:'true' ,
            dicUrl:'/api/blade-/zd/custom/getListDefault',
            dicMethod: "post",  
            dicQuery: {  },
            props: {
              label: "custName",
              value: "id",
            }, 
      
          
          },
          {
            label: "申请银行",
            prop: "bankName",
            width: 160,
            display: false,
            overHidden: true
          },          
          {
            label: "申请银行",
            prop: "bankId",
            hide: true,
            search: true,  
            width: "160",
            type: "select",
            filterable:'true' ,
            dicUrl:'/api/blade-/zd/bank/getListDefault',
            dicMethod: "post",  
            dicQuery: {  },
            props: {
              label: "bankName",
              value: "id",
            }, 

          },

          {
            label: "申请转贷金额",
            prop: "quota",
            width: "160",
            formslot: true,
            sortable: "custom",
            formatter: (row, value, label, column) => {
              
                return this.getMoney(value);
              
            }
          },
          {
            label: "使用费率",
            prop: "loanRate",
            width: "100",
            dataType: "number",
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            dicMethod: "get",
            dicQuery: {},
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            display: true,
            formatter: (row, value, label, column) => {
              return value > -1 ? value * 100 + "%": ""
            }
            
          },

          {
            label: "客户经理",
            prop: "managerName",
            display: false,
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,

            search: true,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.$refs.paymentmanage.selectPersonClick();
            },
          },
          {
            label: "收尾时间",
            prop: "closeTime",
            width:"100",
            display:false,
            type: "date",
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
          },

          {
            label: "收尾时间",
            prop: "closeTime1",
            width:"100",
            type: "daterange", 
              format: "yyyy-MM-dd",
              startPlaceholder: '开始',
              endPlaceholder: '结束',
              valueFormat: "yyyy-MM-dd",  
               hide:true,
            display: true,
            hideshow: true
          }
        ]
      },
     
    };
  },
  components: {
    TagsCloud,
    Paymentmanage,
    Examinelist
  },
  // created() {
  //   this.onload();
  // },
  mounted() {
    this.optionColumn = this.deepClone(this.option.column)
  },    
  activated() {
    this.onload();
  },
  computed: {
    ...mapGetters(["permission"])
  },
  methods: {
     
    onload() {
      api
        .projectgetCloseList({
          firstNum: 0,
          num: 10
        })
        .then(res => {
           
          this.examinelist = res.data.data.shlb;
          this.authority = res.data.data.hasAuditRight;
          this.financial=res.data.data.financial
        })
        .catch(res => {
           
        });
    },

    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },
    cloudTages(data) {
      this.files = data;
      
      // this.$emit("cloudTages", data);
    }
  }
};
</script>
<style lang="scss" scoped>
.bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      // font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  /deep/ .el-range-separator{
  width: 20px !important;
}
/deep/.el-badge__content{
  line-height: 17px;
    padding: 0 5px;
}
}
</style>
